/**
 * Redux actions for the key shortcuts.
 * @module redux/actions/keyShortcuts
 */

import { createAction } from 'redux-actions';

export const SET_MODIFIER_STATE = 'keyShortcuts/SET_MODIFIER_STATE';

export const setModifierKeyState = (active) => createAction(SET_MODIFIER_STATE)({ active });

export const actions = {
  setModifierKeyState
};



// WEBPACK FOOTER //
// ./app/actions/keyShortcuts.js